import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { images } from '../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const rise = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 24
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease
    }
  };
  return <section id="top" className="relative flex min-h-[100svh] w-full items-end overflow-hidden bg-forest-950" data-id="element-10" data-mp="128yy08bm5nwj">
      <img src={images.terrace} alt="La terrasse du Bistrot Jeanot un soir d'été, guirlandes allumées et tables pleines" className="absolute inset-0 h-full w-full object-cover" data-id="element-11" data-mp="xb5s7ge82vws" />
      <div className="absolute inset-0 bg-forest-950/60" aria-hidden="true" data-id="element-12" data-mp="neax77h5rdn9" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-forest-950/50" aria-hidden="true" data-id="element-13" data-mp="3d33h34xud5nx" />

      <div className="relative mx-auto w-full max-w-7xl px-6 pb-16 pt-32 lg:px-10 lg:pb-20" data-id="element-14" data-mp="381nqyygt48yo">
        <motion.p {...rise(0.05)} className="mb-6 text-sm text-cream-100/80" data-id="element-15" data-mp="3j9u06x1wdkkr">
          Restaurant & bar à vin · Pontenx-les-Forges
        </motion.p>

        <motion.h1 {...rise(0.12)} className="font-serif font-light leading-[0.85] text-cream-50 text-[clamp(4.5rem,15vw,13rem)]" data-id="element-16" data-mp="39acx8ne15ksh">
          Le Bistrot
        </motion.h1>

        <div className="mt-2 flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-17" data-mp="30iazwxz9ckmf">
          <motion.span {...rise(0.2)} className="font-script leading-none text-ember-400 text-[clamp(4rem,10vw,8.5rem)] md:pl-[12%]" aria-hidden="true" data-id="element-18" data-mp="358rdci32w68s">
            Jeanot
          </motion.span>

          <motion.div {...rise(0.28)} className="max-w-sm md:pb-6" data-id="element-19" data-mp="2vjpxqt0g3qvc">
            <p className="font-serif text-2xl leading-snug text-cream-50 md:text-3xl" data-id="element-20" data-mp="2hinaicxpsaiu">
              La cuisine est une histoire d’amour.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-cream-100/75" data-id="element-21" data-mp="2ljz0wkoewzs3">
              Produits frais et de saison, vins choisis et une terrasse sous les guirlandes.
            </p>
            <div className="mt-6 flex flex-wrap gap-3" data-id="element-22" data-mp="n9qira2x6u7y">
              <a href="#carte" className="rounded-full bg-cream-100 px-6 py-3 text-sm font-medium text-forest-950 transition-colors duration-150 hover:bg-ember-400" data-id="element-23" data-mp="ibozop5huuwh">
                Découvrir la carte
              </a>
              <a href="#infos" className="rounded-full border border-cream-100/40 px-6 py-3 text-sm font-medium text-cream-50 transition-colors duration-150 hover:border-cream-100" data-id="element-24" data-mp="1ayt6mzo5djaw">
                Horaires & accès
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}